namespace appn.posthog {

    export function capture(eventName: string, properties?: any) {
        try {
            captureInternal(eventName, properties);
        }
        catch {
            // Suppress exceptions to avoid breaking calling JS
        }
    }
    
    function captureInternal(eventName: string, properties?: any) {
        if (!(window as any).posthog || !appn.requestProvider.isTrialing || !appn.requestUser.allowUsageAnalytics)
            return;

        if (window.location.href.toLowerCase().indexOf('backoffice') > -1)
            return;

        const props = properties || {};
        props.ts = props.ts || new Date().toISOString();
        props.providerId = appn.requestProvider.id;
        props.userId = appn.requestUser.id;
        props.isFirstSession = appn.requestUser.isFirstSession;

        (window as any).posthog.capture(eventName, props);
    }

    export function init() {
        // Track menu clicks
        $('.main-sidebar .nav-link').on('click', function() {
            const $this = $(this);
            const label = $this.find('p').text().trim();
            const href = $this.attr('href');

            if (!href || href === '#')
                return;
            
            appn.posthog.capture('menu_click', {
                label: label,
                href: href ? href.split('?')[0] : href
            });
        });

        // Track time on page
        const startTime = new Date().getTime();
        $(window).on('beforeunload', function() {
            const endTime = new Date().getTime();
            const durationMs = endTime - startTime;
            
            appn.posthog.capture('page_view_duration', {
                durationMs: durationMs,
                path: window.location.pathname
            });
        });
    }
}
